import { useEffect } from 'react';

type Options = {
  isActive: boolean;
  isInsideSelectors: string[]; // CSS селекторы элементов, клики по которым считаем «внутри»
  onClose: () => void;
};

export function useCloseOnOutsideOrEsc({ isActive, isInsideSelectors, onClose }: Options) {
  useEffect(() => {
    if (!isActive) return;

    const clickListener = (event: MouseEvent) => {
      event.stopPropagation();
      const target = event.target as HTMLElement | null;
      if (!target) return;

      const isInside = isInsideSelectors.some((sel) => !!target.closest(sel));
      if (!isInside) onClose();
    };

    const keyListener = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('click', clickListener);
    document.addEventListener('keydown', keyListener);

    return () => {
      document.removeEventListener('click', clickListener);
      document.removeEventListener('keydown', keyListener);
    };
  }, [isActive, isInsideSelectors, onClose]);
}
